<template>
  <div v-if="getUser" class="home">
    <main>
      <div class="father">
        <router-view v-if="load"/>
      </div>
    </main>

    <header>
      <Header />
    </header>

    <nav>
      <Sidebar />
    </nav>

    <AnnouncementPopup />
  </div>
</template>

<script>
  import Header from './dashboard/Header'
  import Sidebar from './dashboard/Sidebar'
  import AnnouncementPopup from './shares/AnnouncementPopup'
  import GetAccount from '@/mixins/GetAccount'
  import GetUser from '@/mixins/GetUser'
  import GetAccountApps from '@/mixins/GetAccountApps'

  export default {
    components: { Header, Sidebar, AnnouncementPopup },
    async created() {
      const keyStartPath = 'startPath'

      if (!this.hasUser) {
        this.$ls.set(keyStartPath, this.$route.fullPath, {minutes: 1, withoutKey: true})
        await this.$router.push('/login')
      } else if (this.toWizard())
        await this.$router.push('/wizard')
      else {
        await this.loadAppsAndAccountApps()
        this.load = true

        let startPath = this.$ls.get(keyStartPath, { withoutKey: true })
        if (startPath && startPath !== '/' && startPath !== this.$route.fullPath) {
          const isBackNavigation = window.history.state && window.history.state.back
          if (!isBackNavigation) {
            await this.$router.push(startPath)
          }
        }

        this.$ls.remove(keyStartPath, { withoutKey: true })
      }
    },
    data() {
      return {
        env: process.env.VUE_APP_ENV,
        load: false,
      }
    },
    methods: {
      toWizard() {
        if (!this.hasAccount)
          return true
        if (this.getAccount.accountType === 'partner')
          return false
        if (!this.getAccount.step || this.getAccount.step < 8)
          return true

      },
    },
    mixins: [GetAccount, GetUser, GetAccountApps],
    name: 'Dashboard'
  }
</script>

<style lang="scss" scoped>

@import "src/assets/_main.scss";

  main {
    overflow-y: auto;
    padding: 0;
    grid-area: grid-main;
  }

  .home {
    display: grid;
    height: 100vh;
    grid-template-columns: 170px 1fr;
    grid-template-rows: 91px 1fr;
    grid-template-areas:
      'grid-header grid-header'
      'grid-nav grid-main';
  }

  .father { position: relative }

  header { z-index: 10 }
  nav { z-index: 9 }

  .env {
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-content: center;
    z-index: 10;
    color: red;
    position: fixed;
    top: 5px;
    left: 30%;
    width: 50%;
    background: #ffff00CC;
    height: 30px;
    border-radius: 15px;
    border: 2px red solid;
    transition-duration: 1s;
    transition-delay: 2s;

    animation: MoveUpDown 5s linear infinite
  }

  .env:hover {
    animation: 0;
    height: 0;
    border: 0;
    transition: 1ms;
  }

  @keyframes MoveUpDown {
    50% {
      //width: 30%;
      //left: 30%;
      border: 2px blue solid;
      color: blue;
      background: #ffff0066;
    }
  }

</style>
